import { render, staticRenderFns } from "./CardTopSearches.vue?vue&type=template&id=77ed694e&"
import script from "./CardTopSearches.vue?vue&type=script&lang=js&"
export * from "./CardTopSearches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports